import { ANONYMOUS_SESSION_ID } from '@dtx-company/true-common/src/constants/sessionId'
import { AssetTypes } from '@app/code/src/types/asset-types.types'
import { FLOWCODE_API_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { IthacaJwt } from '@dtx-company/ithaca-sdk/src'
import Cookies from 'universal-cookie'

interface FileUploadResponse {
  id: string
  file: string
  asset_type: AssetTypes
  asset_name: string
  tags: string[]
  batch: string | null
  cdn_url: string
}

interface UploadFileOptions {
  assetType?: AssetTypes
  assetName?: string
}

const cookies = new Cookies()

export const uploadFile = async (
  file: File,
  options: UploadFileOptions,
  jwt?: IthacaJwt | null
): Promise<FileUploadResponse> => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('asset_type', options.assetType || AssetTypes.FILE)
  formData.append('asset_name', options.assetName ?? file.name)

  const anonSessionId = cookies.get(ANONYMOUS_SESSION_ID)
  const headers = jwt
    ? { Authorization: `Bearer ${jwt}` }
    : { ...(anonSessionId && { AnonymousSessionId: anonSessionId }) }

  const res = await fetch(`${FLOWCODE_API_ENDPOINT}/v2/flowcode/file`, {
    method: 'POST',
    body: formData,
    headers
  })

  if (res.status !== 201) throw new Error('error uploading file')
  return res.json() as Promise<FileUploadResponse>
}
